import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC } from 'react'

import { partnerBasicInfoFields } from '../../../../../configs'
import { LocationsAndCount } from '../../../../locationsAndCount/LocationsAndCount'

import styles from './WarehousesEditMode.module.scss'

interface IWarehousesEditModeProps {
  isApplicable: boolean
  locations: string
  count: Nullable<number>
}

export const WarehousesEditMode: FC<IWarehousesEditModeProps> = ({
  isApplicable,
  locations,
  count,
}) => {
  return (
    <div className={styles.root}>
      <LocationsAndCount
        isApplicable={isApplicable}
        locations={locations}
        count={count}
        countFieldName={partnerBasicInfoFields.warehouseCount}
        locationsFieldName={partnerBasicInfoFields.warehouseLocations}
      />
    </div>
  )
}
